import { IKImage } from "imagekitio-react";
import React from "react";
import SingleItemTicker from "./SingleItemTicker";
import { useSelector } from "react-redux";
import { selectReferralDetails } from "../redux/otherDetailsSlice";

const ReferralNav = () => {
  const referralData = useSelector(selectReferralDetails)
  return (
  <SingleItemTicker text={<div className="text-[12px] md:text-[16px] text-white font-semibold">{referralData?.FRIEND_NAME} <span className="text-white/50 font-normal ml-1 md:text-[14px]">got certified & recommends you should too!</span></div>}/>
  );
};

export default ReferralNav;
